import {Stack} from "@src/CommonComponents/Stack/Stack"
import styles from "./settingsPage.module.less"
import {logOut, useCredentialsStore} from "@src/Store/userStore.ts";
import {
    Body_12_Coral_Empasis_12, Body_12_Coral_Primary_Regular12,
    Body_14_Coral_Primary_Regular_14,
    Body_14_Coral_Strong_emphasis_14,
    Body_16_Coral_Emphasis_16,
    Title_20_Coral_Empasis_20,
    Title_20_Coral_Strong_emphasis_20,
    Title_24_Coral_Strong_emphasis_24,
    Title_34_Coral_Strong_emphasis_34
} from "@UI/typography/generated/typography.tsx";
import {Gt} from "@src/i18n/Gt";
import {Calendar} from "@UI/components/icons/Calendar.tsx";
import {MenuLinkButton} from "@src/CommonComponents/MenuLinkButton/MenuLinkButton.tsx";
import React from "react";
import {LogIn} from "@UI/components/icons/LogIn.tsx";
import {ShieldWarning} from "@UI/components/icons/ShieldWarning.tsx";
import {CircleHelp} from "@UI/components/icons/CircleHelp.tsx";
import {File} from "@UI/components/icons/File.tsx";
import {Home} from "@UI/components/icons/Home.tsx";
import {Gear} from "@UI/components/icons/Gear.tsx";
import {useLocation} from "react-router";
import {Modal} from "@src/CommonComponents/Modal/Modal.tsx";
import {ClearLocalDbModal} from "@src/Modals/ClearLocalDbModal.tsx";
import {LanguageSwitcher} from "@src/CommonComponents/LanguageSwitcher/LanguageSwitcher.tsx";
import {StatementsMenuButton} from "@src/Pages/Statement/StatementList.tsx";
import {RequestsPageMenuMutton} from "@src/Pages/RequestsPage/RequestsPage.tsx";
import {CalendarMenuButton} from "@src/Pages/Calendar/CalendarPage.tsx";
import {FileEditIco} from "@UI/components/icons/FileChange.tsx";
import {backendUrl} from "@src/utils/backendUrl.ts";
import {Employee} from "@src/httpClient/__generated__/Api.ts";
import {Avatar} from "@UI/components/Avatar/Avatar.tsx";

export const AvatarWithInfo = ({employee = null}: { employee?: Employee | null }) => {
    return (
        <Stack className={styles.whiteBoard} gap={16} alignItems={"center"} justifyContent={"flex-start"}>
            <Stack className={styles.avatar} alignItems={"center"} justifyContent={"center"}>
                <Avatar uri={employee?.avatar && backendUrl(employee.avatar)}size={60} placeholder={(
                    <Title_20_Coral_Strong_emphasis_20>
                        {employee?.last_name?.[0] || "?"}
                    </Title_20_Coral_Strong_emphasis_20>
                )}/>
            </Stack>
            <Stack direction={"column"} gap={4} alignItems={"flex-start"} justifyContent={"flex-start"}>
                <Body_16_Coral_Emphasis_16>
                    {employee?.last_name} {employee?.first_name}
                </Body_16_Coral_Emphasis_16>
                {employee &&
                    <Stack>
                        <Body_12_Coral_Primary_Regular12>
                            {employee.employee_type
                                ? <Gt prefix={"EmployeeTypeEnum"}>{employee.employee_type}</Gt>
                                : null
                            }
                        </Body_12_Coral_Primary_Regular12>
                        <Body_12_Coral_Primary_Regular12>
                            {employee?.employee_code ?? null}
                        </Body_12_Coral_Primary_Regular12>
                    </Stack>
                }
            </Stack>
        </Stack>
    )
}

export const UserAvatar = () => {
    const employee = useCredentialsStore(x => x.employee)
    return (
        <Stack className={styles.whiteBoard} gap={16} alignItems={"center"} justifyContent={"flex-start"}>
            <Stack className={styles.avatar} alignItems={"center"} justifyContent={"center"}>
                <Avatar uri={employee?.avatar && backendUrl(employee.avatar)}size={70} placeholder={(
                    <Title_20_Coral_Strong_emphasis_20>
                        {employee?.last_name?.[0] || "?"}
                    </Title_20_Coral_Strong_emphasis_20>
                )}/>
            </Stack>
            <Stack>
                <Title_24_Coral_Strong_emphasis_24>
                    {employee?.last_name} {employee?.first_name}
                </Title_24_Coral_Strong_emphasis_24>
            </Stack>
        </Stack>
    )
}

export const UserAvatarSmall = () => {
    const employee = useCredentialsStore(x => x.employee)

    return (
        <Stack className={styles.whiteBoard} gap={16} alignItems={"center"} justifyContent={"flex-start"}>
            <Stack className={styles.avatar} alignItems={"center"} justifyContent={"center"}>
                <Avatar uri={employee?.avatar && backendUrl(employee.avatar)}size={60} placeholder={(
                    <Title_20_Coral_Strong_emphasis_20>
                        {employee?.last_name?.[0] || "?"}
                    </Title_20_Coral_Strong_emphasis_20>
                )}/>

            </Stack>
            <Stack>
                <Title_20_Coral_Empasis_20>
                    {employee?.last_name} {employee?.first_name}
                </Title_20_Coral_Empasis_20>
            </Stack>
        </Stack>
    )
}

export const InlineMenuItems = () => {
    const location = useLocation()
    return (
        <>
            <MenuLinkButton href={"/"} icon={<Home size={22}/>}
                            active={location?.pathname?.startsWith("/check-in")}>
                <Body_12_Coral_Empasis_12>
                    <Gt>Home</Gt>
                </Body_12_Coral_Empasis_12>
            </MenuLinkButton>
            <MenuLinkButton href={"/attendance-history/"} icon={<Calendar size={22}/>}
                            active={location?.pathname?.startsWith("/attendance-history/")}>
                <Body_12_Coral_Empasis_12>
                    <Gt>Attendance history</Gt>
                </Body_12_Coral_Empasis_12>
            </MenuLinkButton>
            <CalendarMenuButton inline/>
            <MenuLinkButton href={"/requests/"} icon={<FileEditIco size={22}/>}
                            active={location?.pathname?.startsWith("/requests/")}>
                <Body_12_Coral_Empasis_12>
                    <Gt>Requests</Gt>
                </Body_12_Coral_Empasis_12>
            </MenuLinkButton>
        </>
    )
}

export const MainMenu = () => {
    const [showModal, setShowModal] = React.useState(false);
    const isManager = useCredentialsStore(x => !!x.employee?.is_manager)
    return (
        <>
            {showModal &&
                <Modal onClose={() => {
                    setShowModal(false)
                }}>
                    <ClearLocalDbModal close={() => setShowModal(false)}/>
                </Modal>
            }
            <Stack direction={"column"} gap={24} className={styles.subMenuPage}>
                <Stack direction={"column"} gap={8}>
                    <UserAvatar/>
                    <MenuLinkButton href={"/attendance-history/"} icon={<Calendar size={22}/>}>
                        <Body_16_Coral_Emphasis_16>
                            <Gt>Attendance history</Gt>
                        </Body_16_Coral_Emphasis_16>
                    </MenuLinkButton>
                    <StatementsMenuButton noPadding={false}/>
                    <RequestsPageMenuMutton noPadding={false}/>
                    <CalendarMenuButton/>
                    <Body_14_Coral_Primary_Regular_14>
                        <Gt>Misc</Gt>
                    </Body_14_Coral_Primary_Regular_14>
                    <MenuLinkButton href={"/settings/terms/"} icon={<File size={22}/>}>
                        <Body_16_Coral_Emphasis_16>
                            <Gt>Terms of service</Gt>
                        </Body_16_Coral_Emphasis_16>
                    </MenuLinkButton>
                    <MenuLinkButton href={"/settings/policy/"} icon={<ShieldWarning size={22}/>}>
                        <Body_16_Coral_Emphasis_16>
                            <Gt>Privacy Policy</Gt>
                        </Body_16_Coral_Emphasis_16>
                    </MenuLinkButton>
                    <MenuLinkButton href={"/settings/faq/"} icon={<CircleHelp size={22}/>}>
                        <Body_16_Coral_Emphasis_16>
                            <Gt>FAQ</Gt>
                        </Body_16_Coral_Emphasis_16>
                    </MenuLinkButton>
                    {isManager &&
                        <MenuLinkButton href={"/admin"} icon={<Gear size={22}/>}>
                            <Body_16_Coral_Emphasis_16>
                                <Gt>Management</Gt>
                            </Body_16_Coral_Emphasis_16>
                        </MenuLinkButton>
                    }
                    <MenuLinkButton onClick={() => logOut()} icon={<LogIn size={22}/>}>
                        <Body_16_Coral_Emphasis_16>
                            <Gt>Logout</Gt>
                        </Body_16_Coral_Emphasis_16>
                    </MenuLinkButton>
                </Stack>

                <Stack justifyContent={"space-between"}>
                    <Body_14_Coral_Primary_Regular_14>
                        <Gt>App information</Gt>
                    </Body_14_Coral_Primary_Regular_14>
                    <Body_14_Coral_Strong_emphasis_14 onClick={() => setShowModal(true)}>
                        {__APP_VERSION__}
                    </Body_14_Coral_Strong_emphasis_14>
                </Stack>

                <LanguageSwitcher/>
            </Stack>
        </>
    )
}


export const FlyMainMenu = () => {
    const isManager = useCredentialsStore(x => !!x.employee?.is_manager)
    return (
        <Stack direction={"column"} gap={24} className={styles.flyMenuPage}>
            <UserAvatarSmall/>
            <LanguageSwitcher/>
            <StatementsMenuButton/>
            {isManager &&
                <MenuLinkButton href={"/admin"} icon={<Gear size={22}/>} style={{padding: 0}}>
                    <Body_16_Coral_Emphasis_16>
                        <Gt>Management</Gt>
                    </Body_16_Coral_Emphasis_16>
                </MenuLinkButton>
            }
            <MenuLinkButton href={"/settings/terms/"} icon={<File size={22}/>} style={{padding: 0}}>
                <Body_16_Coral_Emphasis_16>
                    <Gt>Terms of service</Gt>
                </Body_16_Coral_Emphasis_16>
            </MenuLinkButton>
            <MenuLinkButton href={"/settings/policy/"} icon={<ShieldWarning size={22}/>} style={{padding: 0}}>
                <Body_16_Coral_Emphasis_16>
                    <Gt>Privacy Policy</Gt>
                </Body_16_Coral_Emphasis_16>
            </MenuLinkButton>
            <MenuLinkButton href={"/settings/faq/"} icon={<CircleHelp size={22}/>} style={{padding: 0}}>
                <Body_16_Coral_Emphasis_16>
                    <Gt>FAQ</Gt>
                </Body_16_Coral_Emphasis_16>
            </MenuLinkButton>
            <MenuLinkButton onClick={() => logOut()} icon={<LogIn size={22}/>} style={{padding: 0}}>
                <Body_16_Coral_Emphasis_16>
                    <Gt>Logout</Gt>
                </Body_16_Coral_Emphasis_16>
            </MenuLinkButton>

            <Stack justifyContent={"flex-start"} gap={26}>
                <Body_14_Coral_Primary_Regular_14>
                    <Gt>App information</Gt>
                </Body_14_Coral_Primary_Regular_14>
                <Body_14_Coral_Strong_emphasis_14>
                    {__APP_VERSION__}
                </Body_14_Coral_Strong_emphasis_14>
            </Stack>
        </Stack>
    )
}